import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getSelectedTableView } from "owa-mail-list-store";
import getContextFolderIdForTable from "owa-mail-list-store/lib/utils/getContextFolderIdForTable";
import { isMailRibbonCustomized } from "owa-mail-ribbon-store/lib/store/store";
import { type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import doesFolderIdEqualName from "owa-session-store/lib/utils/doesFolderIdEqualName";
import type { ReadOnlyRibbonControlDefProps } from "./RibbonControlDefinitionProps";
import { getItem } from "./getItem";
import { getRibbonMailboxInfo } from "./getRibbonMailboxInfo";

export type ReportPromotionTabId = MailRibbonTabId.Tab_Home | MailRibbonTabId.Tab_Read;

export default function shouldPromoteNotJunk(props: ReadOnlyRibbonControlDefProps, tabId: ReportPromotionTabId): boolean {
    if (!isGlobalFeatureEnabled("tri-promote-not-junk")) {
        return false;
    }
    
    const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);
    if (!isInJunkFolder(props, mailboxInfo)) {
        return false;
    }
    
    // The Read tab can't be customized, but promoting on Home would override the user's layout.
    if (tabId === 1 && isMailRibbonCustomized(mailboxInfo)) {
        return false;
    }
    
    return true;
}

function isInJunkFolder(props: ReadOnlyRibbonControlDefProps, mailboxInfo: MailboxInfo): boolean {
    if (props.itemId) {
        const parentFolderId = getItem(props.itemId)?.ParentFolderId?.Id;
        return !!parentFolderId && doesFolderIdEqualName(parentFolderId, "junkemail", mailboxInfo);
    }
    
    // Unlike the JunkNotJunk label, Junk-scoped search results are intentionally not promoted.
    const selectedTableView = getSelectedTableView();
    const contextFolderId = selectedTableView && getContextFolderIdForTable(selectedTableView);
    return !!contextFolderId && doesFolderIdEqualName(contextFolderId, "junkemail", mailboxInfo);
}
